/**
 * KMMO kit icons: thin line glyphs (24×24, `currentColor`), the gold coin, class crest emblems
 * and the painted resource icons that already ship in public/assets/icons.
 */
import { svg } from '../ui/dom';

const line = (body: string, cls = ''): string =>
  `<svg class="km-ico ${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">${body}</svg>`;
const F = 'fill="currentColor" fill-opacity="0.22"';

export const KM_ICON = {
  back: '<path d="M10 5 3.5 12 10 19"/><path d="M4 12h16.5"/><path d="M14 8.5 10.5 12 14 15.5"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 10.5v6"/><circle cx="12" cy="7.4" r="0.6" fill="currentColor"/>',
  mail: '<rect x="3" y="5.5" width="18" height="13" rx="1.2"/><path d="M3.5 6.5 12 13l8.5-6.5"/>',
  settings: '<circle cx="12" cy="12" r="3.2"/><path d="M12 2.8v2.6M12 18.6v2.6M2.8 12h2.6M18.6 12h2.6M5.5 5.5l1.9 1.9M16.6 16.6l1.9 1.9M5.5 18.5l1.9-1.9M16.6 7.4l1.9-1.9"/><circle cx="12" cy="12" r="6.6"/>',
  exit: '<path d="M14 4H6.5v16H14"/><path d="M10.5 12H21M17.5 8.5 21 12l-3.5 3.5"/>',
  lock: '<rect x="5" y="10.5" width="14" height="10" rx="1.5" fill="currentColor" fill-opacity="0.18"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/><path d="M12 14.5v2.5"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  minus: '<path d="M5 12h14"/>',
  star: `<path fill="currentColor" d="M12 2.8l2.7 5.8 6.3.7-4.7 4.3 1.3 6.3L12 16.7l-5.6 3.2 1.3-6.3L3 9.3l6.3-.7z"/>`,
  diamond: `<path ${F} d="M12 3l9 9-9 9-9-9z"/><path d="M12 7.5 16.5 12 12 16.5 7.5 12z"/>`,
  chest: `<path ${F} d="M3.5 10h17v9.5h-17z"/><path d="M3.5 10a3.5 3.5 0 0 1 3.5-4.5h10a3.5 3.5 0 0 1 3.5 4.5"/><path d="M3.5 13h17M10.5 12h3v3h-3z"/>`,
  // Navigation / tabs
  hero: `<path ${F} d="M5 13a7 7 0 0 1 14 0v6h-4.5v-4h-5v4H5z"/><path d="M12 6v8M8.5 10h7"/>`,
  skills: `<path ${F} d="M12 2.5 14 10l7.5 2-7.5 2-2 7.5-2-7.5-7.5-2 7.5-2z"/><circle cx="12" cy="12" r="1.6"/>`,
  forge: `<path ${F} d="M3 8h14c0 3-2.5 4.5-5 4.5V15h3v3H7v-3h3v-2.5C6 12.5 3 11 3 8z"/><path d="M17 8h4"/>`,
  rank: `<path ${F} d="M7 3.5h10v5a5 5 0 0 1-10 0z"/><path d="M7 5H4a3 3 0 0 0 3 4.5M17 5h3a3 3 0 0 1-3 4.5M12 13.5V17M8.5 20.5h7M9.5 17h5v3.5h-5z"/>`,
  hammer: `<path ${F} d="M13 3.5l6.5 6.5-2.5 2.5-6.5-6.5z"/><path d="M11.8 9.7 3.5 18a1.4 1.4 0 0 0 2 2l8.3-8.3"/>`,
  layers: `<path ${F} d="M12 3.5 21 8l-9 4.5L3 8z"/><path d="M3 12l9 4.5 9-4.5M3 16l9 4.5 9-4.5"/>`,
  dungeon: `<path ${F} d="M4 21V9l8-5.5L20 9v12z"/><path d="M9.5 21v-5.5a2.5 2.5 0 0 1 5 0V21"/>`,
  guild: `<path ${F} d="M6.5 3.5h11v14l-5.5-3.2-5.5 3.2z"/><path d="M9.5 7.5h5M9.5 10.5h5M4.5 3.5h15"/>`,
  calendar: `<rect x="3.5" y="5" width="17" height="15" rx="1.2" ${F}/><path d="M3.5 9.5h17M8 3v4M16 3v4M7.5 13h2M11 13h2M14.5 13h2M7.5 16.5h2M11 16.5h2"/>`,
  // Inventory tabs
  helm: `<path ${F} d="M4.5 15a7.5 7.5 0 0 1 15 0v4.5h-5v-4h-5v4h-5z"/><path d="M12 7.5v7"/>`,
  potion: `<path ${F} d="M9.5 3h5v5.2l3.6 6.4A4.2 4.2 0 0 1 14.4 21H9.6a4.2 4.2 0 0 1-3.7-6.4L9.5 8.2z"/><path d="M8.6 3h6.8M7.4 14h9.2"/>`,
  gem: `<path ${F} d="M5.5 9 9 4.5h6L18.5 9 12 20.5z"/><path d="M5.5 9h13M9 4.5 12 9l3-4.5M12 9v11.5"/>`,
  leaf: `<path ${F} d="M5 19c0-9 5-14 15-14 0 10-5 15-14 15"/><path d="M5 19 13 11"/>`,
  bag: `<path ${F} d="M7 9.5h10l2 10.5H5z"/><path d="M9.5 9.5 8 4.5h8l-1.5 5M9 6.5h6"/>`,
  // Stats
  power: '<path d="M4 4l11 11M15 15l-2 2M15 15l2-2M17.5 17.5 20 20"/><path d="M20 4 9 15M9 15l2 2M9 15l-2-2M6.5 17.5 4 20"/>',
  strength: `<path ${F} d="M6 20c-2-3-1.5-7 1.5-9.5L9 6.5c.5-1.5 2.5-2 3.5-.8l.5.8-1.5 3.5c3-1 6.5.5 7.5 3.5S18 20 14 20z"/>`,
  stamina: `<path ${F} d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10C19.5 15.4 12 20 12 20z"/>`,
  crit: `<path ${F} d="M12 2.5l1.8 5.6 5.4-2.4-2.6 5.3 5.4 1.8-5.4 1.8 2.6 5.3-5.4-2.4L12 23l-1.8-5.5-5.4 2.4 2.6-5.3L2 12.8l5.4-1.8-2.6-5.3 5.4 2.4z" transform="scale(.92) translate(1 0)"/>`,
  haste: '<path d="M20 12a8 8 0 1 1-3-6.2"/><path d="M15.5 12a3.5 3.5 0 1 1-1.5-2.9"/><path d="M17 3.5v2.8h-2.8"/>',
  mastery: '<path d="M12 3v18M7 3v5a5 5 0 0 0 10 0V3M9.5 21h5"/>',
  versatility: `<path ${F} d="M12 3l7.5 3v5.5c0 4.6-3.2 8-7.5 9.5-4.3-1.5-7.5-4.9-7.5-9.5V6z"/>`,
  expertise: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="0.8" fill="currentColor"/>',
  spirit: `<path ${F} d="M12 3c3 3.5 5 6.5 5 9.5a5 5 0 0 1-10 0C7 9.5 9 6.5 12 3z"/>`,
  ilvl: `<path ${F} d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 8v8M9 11l3-3 3 3"/>`,
} as const;

export type KmIcon = keyof typeof KM_ICON;

export function kmIcon(name: KmIcon, cls = ''): SVGSVGElement {
  return svg(line(KM_ICON[name], `km-ico-${name} ${cls}`.trim()));
}

/** Engraved gold coin (filled, not tinted). */
export function goldCoinSvg(): SVGSVGElement {
  return svg(`<svg class="km-ico km-coin" viewBox="0 0 24 24" aria-hidden="true">
    <defs><radialGradient id="kmCoinG" cx="38%" cy="32%" r="75%"><stop offset="0" stop-color="#fff2b8"/><stop offset=".45" stop-color="#f2c04c"/><stop offset="1" stop-color="#a5691a"/></radialGradient></defs>
    <circle cx="12" cy="12" r="10" fill="url(#kmCoinG)" stroke="#7a4a0f" stroke-width=".8"/>
    <circle cx="12" cy="12" r="6.6" fill="none" stroke="#9a6418" stroke-width="1" opacity=".8"/>
    <path d="M12 7.6l1.3 2.9 3.1.3-2.3 2.1.7 3.1L12 14.4 9.2 16l.7-3.1-2.3-2.1 3.1-.3z" fill="#b97d22" opacity=".9"/>
  </svg>`);
}

// ---------------------------------------------------------------------------
// Class emblems (inside the diamond crest)
// ---------------------------------------------------------------------------

export const CLASS_EMBLEM: Readonly<Record<string, string>> = {
  warden: `<path ${F} d="M12 3l7 2.8v5.4c0 4.6-3 8-7 9.8-4-1.8-7-5.2-7-9.8V5.8z"/><path d="M12 7v10M8.5 10.5h7"/>`,
  lightbinder: `<circle cx="12" cy="12" r="3.6" ${F}/><path d="M12 3v3.5M12 17.5V21M3 12h3.5M17.5 12H21M5.6 5.6l2.5 2.5M15.9 15.9l2.5 2.5M5.6 18.4l2.5-2.5M15.9 8.1l2.5-2.5"/>`,
  blademaster: '<path d="M5 4l10 10M13.5 15.5 15 14l1.5 1.5-1.5 1.5zM16.5 17.5 19.5 20.5"/><path d="M19 4 9 14M10.5 15.5 9 14l-1.5 1.5L9 17zM7.5 17.5 4.5 20.5"/><path d="M5 4l2.8.6M5 4l.6 2.8M19 4l-2.8.6M19 4l-.6 2.8"/>',
  stormcaller: `<path ${F} d="M13.5 2.5 5.5 13.5h5.5l-2 8 9-11.5h-6z"/>`,
};
// +classes: the five base classes (Warrior, Acolyte, Rogue and Mage reuse the old crests).
Object.assign(CLASS_EMBLEM as Record<string, string>, {
  warrior: CLASS_EMBLEM['warden'],
  acolyte: CLASS_EMBLEM['lightbinder'],
  rogue: CLASS_EMBLEM['blademaster'],
  mage: `<path ${F} d="M12 2.8l2.4 6.3 6.8.3-5.3 4.2 1.8 6.6L12 16.4l-5.7 3.8 1.8-6.6-5.3-4.2 6.8-.3z"/>`,
  ranger: '<path d="M6 3c5 3 7 7 7 9s-2 6-7 9"/><path d="M6 3v18"/><path d="M4 12h15M16 9l3 3-3 3"/>',
});

export function classEmblemSvg(classId: string): SVGSVGElement {
  return svg(line(CLASS_EMBLEM[classId] ?? KM_ICON.diamond, `km-emblem km-emblem-${classId}`));
}

// ---------------------------------------------------------------------------
// Painted icons (public/assets/icons)
// ---------------------------------------------------------------------------

const base = (): string => ((import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/').replace(/\/?$/, '/');

/** URL of a painted icon by file stem ("forge_fangsteel", "blademaster_mortal_strike"); `small` = the 64 px copy. */
export function iconUrl(stem: string, small = false): string {
  return `${base()}assets/icons/${stem}${small ? '_64' : ''}.png`;
}

/** Painted icon stems for the Altar Forge resources. */
export const RESOURCE_ICON: Readonly<Record<string, string>> = {
  fangsteel: 'forge_fangsteel',
  sigils: 'forge_sigil',
  venom: 'forge_venom',
  moltskin: 'forge_moltskin',
  eyeFragments: 'forge_eye_fragment',
  blessed: 'forge_blessed',
  'scale.ashen': 'forge_scale_ashen',
  'scale.jade': 'forge_scale_jade',
  'scale.gilded': 'forge_scale_gilded',
  'scale.eternal': 'forge_scale_eternal',
  vaultToken: 'forge_vault_token',
};

/** Ability icon stem ("blademaster.mortal_strike" → "blademaster_mortal_strike"). */
export function abilityIconStem(abilityId: string): string {
  return abilityId.replace(/[.]/g, '_');
}
